/**
 * @file Image Scroller.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Image Scroller component.
 */
const vImageScroller = () => {
	const imageScroller = document.querySelector('.v-image-scroller');

	if (!imageScroller) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const background = imageScroller.querySelector('.v-image-scroller__background');
	const images = imageScroller.querySelector('.v-image-scroller__images');
	const lastBlock = imageScroller.querySelector('.v-image-scroller__block:last-child');

	ScrollTrigger.matchMedia({
		'(min-width: 851px)': () => {
			// Background Descend
			gsap.timeline({
				defaults:      { ease: 'sine.out' },
				scrollTrigger: {
					trigger: imageScroller,
					start:   'top 50%',
					end:     () => {
						const backgroundHeight = background.offsetHeight;
						const imagesHeight = images.offsetHeight;
						const imageScrollerStyle = getComputedStyle(imageScroller).paddingTop;
						const imageScrollerPaddingTop = parseInt(imageScrollerStyle, 10);
						const titleHeight = backgroundHeight - imagesHeight;
						return `${imageScrollerPaddingTop + titleHeight + (imagesHeight / 2) + 100}px center`;
					},
					scrub: true,
				},
			})
				.to('html', {
					backgroundColor: '#000',
				})
				.to(background, {
					y: 100,
				}, '<');

			// Background Pin and image slide
			gsap.to('.v-image-scroller__image:not(:last-child)', {
				opacity:       0,
				xPercent:      (i) => (i % 2 ? -1 : 1) * 50,
				stagger:       1.2,
				duration:      1,
				ease:          'sine.out',
				scrollTrigger: {
					trigger: imageScroller,
					start:   () => {
						const backgroundHeight = background.offsetHeight;
						const imagesHeight = images.offsetHeight;
						const imageScrollerStyle = getComputedStyle(imageScroller).paddingTop;
						const imageScrollerPaddingTop = parseInt(imageScrollerStyle, 10);
						const titleHeight = backgroundHeight - imagesHeight;
						return `${imageScrollerPaddingTop + titleHeight + (imagesHeight / 2) + 100}px center`;
					},
					end: () => {
						const imagesHeight = images.offsetHeight;
						const windowHeight = window.innerHeight;
						const imagesBottom = (windowHeight - imagesHeight) / 2;

						const imageScrollerHeight = imageScroller.offsetHeight;
						const imageScrollerPaddingBottom = parseInt(
							getComputedStyle(imageScroller).paddingBottom,
							10,
						);
						const contentBottom = imageScrollerHeight - imageScrollerPaddingBottom;
						const lastBlockHeight = lastBlock.offsetHeight;

						return `${contentBottom + (imagesBottom - (lastBlockHeight / 2))}px bottom`;
					},
					pin:   '.v-image-scroller__background-wrap',
					scrub: true,
				},
			});
		},
	});
};

export default vImageScroller;
